import React, { useState } from "react";
import style from "./Details.module.scss";
import CaretDown24 from "../../../../assets/svg/icons/common/CaretDown24";
import StatusDot from "../../../../components/StatusDot/StatusDot";
import HeadingWithLine from "../../../../components/HeadingWithLine/HeadingWithLine";

function BusinessProfile({ appData, expandAppDetails }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className={`${style.accordion_item} ${expandAppDetails ? style.expanded : ""}`}
    >
      <div
        className={`${style.accordion_head} ${isOpen ? style.open : ""}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <CaretDown24 />
        <h5>Business Profile</h5>
      </div>
      {isOpen && (
        <>
          <div className={style.accordion_body}>
            <div className={style.data_item}>
              <p className={style.data_label}>
                Products and services description
              </p>
              <p className={style.data_value}>
                {appData?.powerappbusinessprofile?.product_service_sold || "-"}
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>
                Products and/or services are advertised
              </p>
              <p className={style.data_value}>
                {appData?.powerappbusinessprofile?.prod_advertise_desc || "-"}
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>
                3rd party application involved with payment process
              </p>
              <p className={style.data_value}>
                {appData?.powerappbusinessprofile?.thirdparty_delivered_radio?.toUpperCase() ||
                  "No"}
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>
                Business or any associated owner ever been terminated as a
                VISA/MasterCard/Discover/AMEX merchant?
              </p>
              <p className={style.data_value}>{"-"}</p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>
                Business had any ongoing or prior data compromise investigations
              </p>
              <p className={style.data_value}>
                {appData?.powerappbusinessprofile?.prior_data_compromise_invetigation?.toUpperCase() ||
                  "No"}
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>
                Business was previously identified with Visa Risk Programs
              </p>
              <p className={style.data_value}>
                {appData?.creditcardprocess?.identified_visa_risk_program?.toUpperCase() ||
                  "No"}
              </p>
            </div>
            <div className={style.data_item}>
              <p className={style.data_label}>Multiple locations</p>
              <p className={style.data_value}>
                {appData?.powerappbusinessprofile?.is_multiple_locations?.toUpperCase() ||
                  "No"}
              </p>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default BusinessProfile;
